/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserAnalyticsResumeResponse } from '../../models/user-analytics-resume-response';

export interface GetUserAnalytics$Params {
}

export function getUserAnalytics(http: HttpClient, rootUrl: string, params?: GetUserAnalytics$Params, context?: HttpContext): Observable<StrictHttpResponse<UserAnalyticsResumeResponse>> {
  const rb = new RequestBuilder(rootUrl, getUserAnalytics.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserAnalyticsResumeResponse>;
    })
  );
}

getUserAnalytics.PATH = '/api/user/analytics';
